/* global axios */
import ApiClient from './ApiClient';

class PipelineFollowUpRulesAPI extends ApiClient {
  constructor() {
    super('follow-up-rules', { accountScoped: true });
  }

  getUrl(pipelineId) {
    return `${this.baseUrl()}/pipelines/${pipelineId}/follow-up-rules`;
  }

  get(pipelineId) {
    return axios.get(this.getUrl(pipelineId));
  }

  show(pipelineId, ruleId) {
    return axios.get(`${this.getUrl(pipelineId)}/${ruleId}`);
  }

  create(pipelineId, data) {
    return axios.post(this.getUrl(pipelineId), {
      pipeline_follow_up_rule: data,
    });
  }

  update(pipelineId, ruleId, data) {
    return axios.patch(`${this.getUrl(pipelineId)}/${ruleId}`, {
      pipeline_follow_up_rule: data,
    });
  }

  delete(pipelineId, ruleId) {
    return axios.delete(`${this.getUrl(pipelineId)}/${ruleId}`);
  }
}

export default new PipelineFollowUpRulesAPI();
